"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWorkspaceToIdentity = exports.workspaceUrls = void 0;
exports.workspaceUrls = [
    "https://go.accessacloud.com",
    "https://preprodgo.accessacloud.com",
    "https://staginggo.accessacloud.com",
    "https://demogo.accessacloud.com",
    "http://localhost:3000",
    "http://localhost:4792"
];
function mapWorkspaceToIdentity(wsUrl) {
    switch (wsUrl) {
        case "https://go.accessacloud.com":
            return "https://identity.accessacloud.com";
        case "https://staginggo.accessacloud.com":
            return "https://stagingidentity.accessacloud.com";
        case "https://demogo.accessacloud.com":
            return "https://demoidentity.accessacloud.com";
        case "https://preprodgo.accessacloud.com":
        case "http://localhost:3000":
        case "http://localhost:4792":
            return "https://preprodidentity.accessacloud.com";
        default:
            return "";
    }
}
exports.mapWorkspaceToIdentity = mapWorkspaceToIdentity;
